/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Insert_Event_AboveInputs */

const en_shortcut_keys_desc_insert_event_above = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Event_AboveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert event above the currently selected event.`)
};

const fr_shortcut_keys_desc_insert_event_above = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Event_AboveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserer un evenement au-dessus de l'evenement selectionne.`)
};

const de_shortcut_keys_desc_insert_event_above = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Event_AboveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge das Ereignis oberhalb des aktuell ausgewählten Ereignisses ein.`)
};

const it_shortcut_keys_desc_insert_event_above = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Event_AboveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci l'evento sopra l'evento attualmente selezionato.`)
};

const ru_shortcut_keys_desc_insert_event_above = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Event_AboveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставьте событие выше текущего выбранного события.`)
};

const es_shortcut_keys_desc_insert_event_above = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Event_AboveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar evento encima del evento actualmente seleccionado.`)
};

const zh_cn2_shortcut_keys_desc_insert_event_above = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Event_AboveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在当前选中事件上方插入事件。`)
};

const ja_shortcut_keys_desc_insert_event_above = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Event_AboveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在選択されているイベントの上にイベントを挿入します。`)
};

const hi_shortcut_keys_desc_insert_event_above = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Event_AboveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान में चयनित इवेंट के ऊपर एक और इवेंट डालें।`)
};

const pt_pt2_shortcut_keys_desc_insert_event_above = /** @type {(inputs: Shortcut_Keys_Desc_Insert_Event_AboveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insira o evento acima do evento atualmente selecionado.`)
};

/**
* | output |
* | --- |
* | "Insert event above the currently selected event." |
*
* @param {Shortcut_Keys_Desc_Insert_Event_AboveInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_insert_event_above = /** @type {((inputs?: Shortcut_Keys_Desc_Insert_Event_AboveInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Insert_Event_AboveInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_insert_event_above(inputs)
	if (locale === "de") return de_shortcut_keys_desc_insert_event_above(inputs)
	if (locale === "it") return it_shortcut_keys_desc_insert_event_above(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_insert_event_above(inputs)
	if (locale === "es") return es_shortcut_keys_desc_insert_event_above(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_insert_event_above(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_insert_event_above(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_insert_event_above(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_insert_event_above(inputs)
	return en_shortcut_keys_desc_insert_event_above(inputs)
});